import React, { useState, useEffect } from 'react';
import Form from "react-bootstrap/Form";

const SEARCH_TIMEOUT = 250;

export default function EventsSearch(props) {
	const { setSearch } = props;
	const [searchProxy, setSearchProxy] = useState(props.search || '');

	useEffect(() => {
		const timeout = setTimeout(() => setSearch(searchProxy), SEARCH_TIMEOUT);
		return () => clearTimeout(timeout);
	}, [
		searchProxy,
		setSearch,
	]);

	return (
		<Form.Control
			as="input"
			type="text"
			placeholder={props.placeholder || "Search by Event name"}
			value={searchProxy}
			onChange={e => setSearchProxy(e.target.value)}
			className="EventsSearch rounded-0 border-0"
		/>
	);
};
